module.exports = __webpack_public_path__ + "img/logo_free-ecshopx.45bb618d.png";